import { all, call } from "redux-saga/effects";
import { bountiesSagas } from "./bounties/bounties.sagas";
import { competitionsSagas } from "./competitions/competitions.sagas";
import { fixturesSagas } from "./fixtures/fixtures.sagas";
import { notificationsSagas } from "./notifications/notifications.sagas";
import { pairingsSagas } from "./pairings/pairings.sagas";
import { transactionsSagas } from "./transactions/transactions.sagas";
import { userSagas } from "./user/user.sagas";
import { walletSagas } from "./wallet/wallet.sagas";
import { withdrawalsSagas } from "./withdrawals/withdrawals.sagas";

export default function* rootSaga() {
  yield all([
    call(userSagas),
    call(transactionsSagas),
    call(withdrawalsSagas),
    call(bountiesSagas),
    call(competitionsSagas),
    call(fixturesSagas),
    call(pairingsSagas),
    call(walletSagas),
    call(notificationsSagas),
  ]);
}
